import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:postId|socialPostId|authorMemberId|memberId|linkedJourneyPublicationId|linkedLocationId|quotedSocialPostId|locationId|publicationId|parentLocationId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

export const exploreApi = {
  listPosts: (params, options = {}) => travelClient.get(travelEndpoints.explorePosts, {
    params,
    signal: options.signal,
    ...snowflakeJson,
  }),
  likePost: (postId) => travelClient.post(travelEndpoints.likeSocialPost(postId)),
  unlikePost: (postId) => travelClient.post(travelEndpoints.unlikeSocialPost(postId)),
  savePost: (postId) => travelClient.post(travelEndpoints.saveSocialPost(postId)),
  unsavePost: (postId) => travelClient.post(travelEndpoints.unsaveSocialPost(postId)),
  sharePost: (postId, clientRequestId) => travelClient.post(travelEndpoints.shareSocialPost(postId), { clientRequestId }),
};
